import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IPackageCardData } from './k-package-card.interface';
import { eSize } from '../k-cards.component';

@Component({
  selector: 'k-package-card',
  templateUrl: './k-package-card.component.html',
  styleUrls: ['./k-package-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KPackageCardComponent {

  @Input() data: IPackageCardData = {
    id: 'small',
    dollarAmount: '4.68$',
    KMONAmount: '4.11K',
    BNBAmount: '5.22K',
    goldenLabel: '91K',
    title: 'KMON PACKAGE',
    pic: './assets/img/Icon/coins_0.png'
  };
  @Input() isResponsive: boolean = true;
  @Input() size: eSize = eSize.xs //to check if it works also with other sizes;
  @Output() onCardClick: EventEmitter<IPackageCardData> = new EventEmitter<IPackageCardData>

  click() {
    this.onCardClick.emit(this.data);
  }
}
